<template>
  <div class="centerContent">
    <p class="carouselTitle">{{ title }}</p>
    <span class="curso_linha3 azul_site_background"></span>
  </div>
</template>

<script>
export default {
  props:["title"],
  setup () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.centerContent {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.carouselTitle {
  font-family: 'Montserrat Bold';
  font-size: 30px;
  margin-top: 0px;
  color: var(--title-color,#333333);
  display: inline-block;
  margin-bottom: 5px;
  padding-top: var(--carousel-title-padding-top,85px);
}

.carouselTitle {
  padding-top: 85px;
}

.curso_linha3 {
  height: 3px;
  display: block;
  width: 150px;
  margin-bottom: 85px;
}

.curso_linha3 {
  margin-bottom: 50px;
}

@media (max-width: 1024px) {
  .carouselTitle {
    font-size: 23px;
    padding-top: 50px;
  }
}

@media (max-width: 767px) {

  .carouselTitle {
    padding-top: var(--carousel-title-padding-top-mobile,50px);
  }

  .carouselTitle {
    font-size: 19px;
  }  

  .curso_linha3 {
    margin-bottom: 30px;
  }
}
</style>